import { useTranslation } from 'react-i18next';
import { MaintenanceTable } from '../../Layouts/DataTable';
import { EApiType, EDataMaintenanceType, EModuleType } from '../../../data/Constants';
import { getProductHierarchy } from '../../../store/states/ProductHierarchySlice';
import { useApiError } from '../../../hooks';

import type { IManagementProps } from '../../../../types';

export const ProductHierarchy = (props: IManagementProps) => {
  const { t } = useTranslation();
  const errorElement = useApiError(EApiType.ProductHierarchyKey);

  if (errorElement) return errorElement;

  return (
    <>
      <h3 className="mainHeader"> {t('header.productHierarchy')} </h3>
      <MaintenanceTable
        token={props.token}
        type={EDataMaintenanceType.ProductHierarchy}
        getDataList={getProductHierarchy}
        moduleType={EModuleType.Datamaintainance}
      />
    </>
  );
};
